export const TRADES_PAGE_TAG_MUTATION_SOURCE = 'trades-page-tag-mutation';
export const TRADES_PAGE_DELETE_MUTATION_SOURCE = 'trades-page-delete-mutation';

export function shouldRefreshTradesForImportedUpdate(event: Event): boolean {
  const source = (event as CustomEvent<{ source?: unknown }>).detail?.source;
  return source !== TRADES_PAGE_TAG_MUTATION_SOURCE && source !== TRADES_PAGE_DELETE_MUTATION_SOURCE;
}

export function removeTagFromTrades<T extends { tags?: unknown }>(trades: T[], matches: (trade: T) => boolean, tag: string): T[] {
  const trimmed = tag.trim();
  if (!trimmed) return trades;
  return trades.map((trade) => {
    if (!matches(trade)) return trade;
    const tags = Array.isArray(trade.tags) ? trade.tags : [];
    return { ...trade, tags: tags.filter((existing) => existing !== trimmed) };
  });
}
